import router from "./router/index";
import store from "./store/index";
import NProgress from "nprogress"; // Progress 
import "nprogress/nprogress.css"; // Progress 
import { getAdminId } from "./utils/auth"; // Check right
import { Message } from "element-ui";
import { asyncRouterMap } from "./router/index";
// permissiom judge
function hasRole(authRules, permissionAuthRules) {
    if (!authRules || authRules.length <= 0) {
        return false;
    }
    if (authRules.indexOf("admin") >= 0) return true; // Admin permission is directly passed through
    if (!permissionAuthRules) return true;
    return authRules.some(role => permissionAuthRules.indexOf(role) >= 0);
}

/**
 * Through meta Role determines whether it matches the current user permission
 * @param authRules
 * @param route
 */
function hasRouterRole(authRules, route) {
    if (
        authRules.indexOf("admin") >= 0 ||
        !route.meta ||
        !route.meta.authRule
    ) {
        return true;
    }
    return authRules.some(
        authRule => route.meta.authRule.indexOf(authRule) >= 0
    );
}

/**
 * Recursively filter the asynchronous routing table and return the routing table that meets the user role permissions
 * @param asyncRouterMap
 * @param authRules
 */
function filterAsyncRouter(asyncRouterMap, authRules) {
    const accessedRouters = asyncRouterMap.filter(route => {
        if (hasRouterRole(authRules, route)) {
            if (route.children && route.children.length) {
                route.children = filterAsyncRouter(route.children, authRules);
            }
            return true;
        }
        return false;
    });
    return accessedRouters;
}

// register global progress.
const whiteList = ["/login", "/401", "/404", "/500"]; // Do not redirect whitelist
router.beforeEach((to, from, next) => {
    NProgress.start(); // open Progress
    if (whiteList.indexOf(to.path) !== -1) {
        // In the login free white list, enter directly
        next();
        return;
    }
    let adminId = getAdminId();
    if (adminId !== "undefined" && adminId !== "" && adminId) {
        // token
        if (to.path === "/login") {
            next({ path: "/" });
            NProgress.done();
            return;
        }
        if (!store.getters.userName &&
            (!store.getters.authRules || store.getters.authRules.length === 0)
        ) {
            // Judge whether the current user has pulled the user information
            store
                .dispatch("userInfo")
                .then(data => {
                    // Pull user_ info
                    const authRules = data.authRules || [];
                    if (!(authRules instanceof Array) ||
                        authRules.length === 0
                    ) {
                        Message.error("Permission verification failed, please contact the administrator~");
                        next({
                            path: "/401",
                            query: { noGoBack: true }
                        });
                        NProgress.done();
                        return;
                    }
                    let accessedRouters = filterAsyncRouter(
                        asyncRouterMap,
                        authRules
                    );
                    // Generate an accessible routing table
                    router.addRoutes(accessedRouters); // Dynamically add accessible routing table
                    next({...to }); // The hack method ensures that addroutes is complete
                    // Set left navigation bar
                    store
                        .dispatch("filterRouter", { accessedRouters })
                        .then(() => {});
                })
                .catch(() => {
                    store.dispatch("fedLogout").then(() => {
                        Message.error("Verification failed, please login again");
                        let redirect = to.fullPath;
                        store.dispatch("loginOut").then(() => {
                            next({
                                path: "/login",
                                query: { redirect: redirect }
                            });
                        });
                    });
                });
            return;
        }
        // If there is no need to change permissions dynamically, you can directly delete the permission judgment below with next() ↓
        if (hasRole(store.getters.authRules, to.meta.authRule)) {
            next(); //
            return;
        }
        next({
            path: "/401",
            query: { noGoBack: true }
        });
        NProgress.done(); // Manually changing the hash redirection of the router in the hash mode will not trigger the aftereach temporary hack SCHEME ps: there is no problem in the history mode. You can delete this line!
        return;
    }
    let redirect = to.fullPath;
    store.dispatch("loginOut").then(() => {
        next({
            path: "/login",
            query: { redirect: redirect }
        });
    }); // Otherwise, redirect all to the login page
    NProgress.done(); // Manually changing the hash redirection of the router in the hash mode will not trigger the aftereach temporary hack SCHEME ps: there is no problem in the history mode. You can delete this line!
});

router.afterEach(() => {
    NProgress.done(); // end Progress
});